import { getUserDetails } from '@repo/api';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from './query-keys';

export const useUserDetailsQuery = (enabled?: boolean) => {
  const query = useQuery({
    enabled,
    queryFn: getUserDetails,
    queryKey: queryKeys.me.all,
  });

  return {
    ...query,
    user: query.data,
  };
};
